const PasswordRequirements = {
  expression: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$^+=!*()@%&.?*@!"[\]:;<{}|~`]).{8,150}$/,
  label:
    'The password needs to be at least 8 characters, including 1 uppercase, 1 lowercase, 1 number and 1 special character',
};

export { PasswordRequirements };
